import { render } from "./IconSunSet.vue?vue&type=template&id=ffb983d8"
import script from "./IconSunSet.vue?vue&type=script&lang=js"
export * from "./IconSunSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__